import { isAxiosError } from "axios";

/**
 * Extracts a human-readable reason from an API error.
 *
 * digifirst-cms returns failures as `{ "error": "<reason>" }` alongside a 4xx/5xx
 * status, but the raw AxiosError only surfaces "Request failed with status code N".
 * Returns the backend reason when present, a friendly message on timeout, and
 * `undefined` otherwise (gateway HTML, network errors, non-axios errors) so callers
 * can fall back to their own generic copy.
 */
export function getApiErrorMessage(error: unknown): string | undefined {
  if (!isAxiosError(error)) {
    return undefined;
  }
  if (error.code === "ECONNABORTED") {
    return "the request timed out";
  }
  const data = error.response?.data;
  if (data && typeof data === "object" && typeof (data as { error?: unknown }).error === "string") {
    return (data as { error: string }).error;
  }
  return undefined;
}
